import React, { createContext } from 'react'
import { useState } from 'react'

const SignContext = createContext()

export const SignProvider = ({ children }) => {
    const [loginPopup, setLoginPopup] = useState(false)
    const [requestCallbackModal, setRequestCallbackModal] = useState({
        status: false,
        project_id: 0,
    })
    const [buSign, setBuSign] = useState({ auction_id: 0, status: false, bu_doc: '' })
    const [kycPopup, setKycPopup] = useState(false)
    const [forgotPasswordPopup, setForgotPasswordPopup] = useState(false)
    const handleLoginPopup = () => {
        setLoginPopup(!loginPopup)
        setKycPopup(false)
    }
    const handleKycPopup = () => {
        setKycPopup(!kycPopup)
        setLoginPopup(false)
    }
    const handleBusign = (id, file) => {
        setBuSign((ele) => {
            return { auction_id: id || 0, status: !ele.status, bu_doc: file || '' }
        })
    }
    const handleRequestCallbackModal = (data) => {
        setRequestCallbackModal({ ...data })
    }
    const handleForgotPasswordPopup = () => {
        setForgotPasswordPopup(!forgotPasswordPopup)
        setLoginPopup(false)
        setKycPopup(false)
    }
    return (
        <SignContext.Provider
            value={{
                loginPopup,
                handleLoginPopup,
                kycPopup,
                setKycPopup,
                handleKycPopup,
                buSign,
                handleBusign,
                setLoginPopup,
                setBuSign,
                setForgotPasswordPopup,
                handleForgotPasswordPopup,
                forgotPasswordPopup,
                handleRequestCallbackModal,
                requestCallbackModal,
            }}
        >
            {children}
        </SignContext.Provider>
    )
}

export default SignContext
